export default "__VITE_ASSET__BDW0KbPh__"